const baseUrl = "https://catalys.portal.nttdataservices.com";
const newImageSrc = "userprofile.png";

const fetchUserData = async () => {
  let userData = {};
  try {
    userData = JSON.parse(sessionStorage.getItem("userData"));
  } catch (error) {
    console.log("No Data found for this key...");
    userData = null;
  }
  if (null === userData) {
    const userPage = await fetch(`${baseUrl}/`);
    const domContentText = await userPage.text();
    const parser = new DOMParser();
    const contentHtml = parser.parseFromString(domContentText, "text/html");

    const carouselItemMain = contentHtml.getElementById("carousel-item-main");
    if (!carouselItemMain) {
      throw new Error("Element with ID 'carousel-item-main' not found");
    }

    const profileLinkElement = carouselItemMain.querySelector("a");
    if (!profileLinkElement || !profileLinkElement.href) {
      throw new Error("Profile page link not found");
    }

    const profilePageLink = contentHtml
      .getElementById("carousel-item-main")
      .childNodes.item(1)?.href;
    const profilePageContent = await fetch(profilePageLink);
    const profilePageContentText = await profilePageContent?.text();
    const profilePageContentHtml = parser.parseFromString(
      profilePageContentText,
      "text/html",
    );

    const avatarElement =
      profilePageContentHtml.getElementsByClassName("avatar")[0];
    if (!avatarElement) {
      throw new Error("Avatar element not found");
    }

    const profileImage = contentHtml
      .getElementsByClassName("avatar")
      .item(0)
      ?.childNodes.item(1).nodeName;

    const profileImageSrc =
      profileImage === "IMG"
        ? (() => {
            const originalSrc = contentHtml
              .getElementsByClassName("avatar")
              .item(0)
              .childNodes.item(1).src;

            if (originalSrc.includes("f1")) {
              return originalSrc.replace("f1", "f3");
            } else if (originalSrc.includes("f2")) {
              return originalSrc.replace("f2", "f3");
            } else {
              return originalSrc;
            }
          })()
        : newImageSrc;

    const headerHeadingElement = profilePageContentHtml
      .getElementsByClassName("header-heading")
      .item(0);

    if (!headerHeadingElement) {
      console.log("Header heading element not found");
      return null;
    }

    const username = headerHeadingElement.textContent;

    let userDetails = [username, profileImageSrc];
    sessionStorage.setItem(
      "userData",
      JSON.stringify({ userName: username, userImage: profileImageSrc }),
    );

    return userDetails;
  } else {
    return [userData.userName, userData.userImage];
  }
};

const fetchUserBadges = async () => {
  const url = `${baseUrl}/local/report/userbadge.php?option=0`;

  let badgeList = [];
  let badgeYearList = [];
  let badgeYears = [];
  try {
    badgeList = JSON.parse(sessionStorage.getItem("userBadges")) || [];
    if (badgeList.length !== 0) {
      return badgeList;
    }
  } catch (error) {
    badgeList = [];
  }
  if (badgeList.length === 0 && badgeYearList.length === 0) {
    var content = await fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error("Error fetching data");
      }
      return response.text();
    });
    const parser = new DOMParser();
    var webContent = parser.parseFromString(content, "text/html");

    const select = webContent.querySelector('select[name="option"]');

    if (select) {
      badgeYears = Array.from(select.options)
        .filter((opt) => opt.value)
        .map((opt) => ({
          value: opt.value,
          text: opt.textContent.trim(),
        }));
    }

    const userBadges = webContent
      .getElementById("issued-badge-table")
      .getElementsByTagName("li");
    badgeList = [];
    for (var i = 0; i < userBadges.length; i++) {
      const li = userBadges.item(i);
      const name = li.querySelector(".badge-name")?.textContent.trim() || "";
      const image = li.querySelector("img")?.src || "";
      const link = li.querySelector("a")?.href || "";
      const tag = "Nttdata course";
      badgeList.push({
        key: i,
        name,
        image,
        link,
        tag,
      });
    }
    const issuedDates = await Promise.all(
      badgeList.map(async (badge) => {
        try {
          const badgeDetail = await fetch(badge.link);
          const badgeHtml = await badgeDetail.text();
          const badgeDoc = parser.parseFromString(badgeHtml, "text/html");
          const issuedDiv = badgeDoc.getElementById("badge-issued-expire");
          let issued = "";
          if (issuedDiv) {
            const small = issuedDiv.querySelector("small");
            if (small) {
              issued = small.textContent.trim().replace(/\s+/g, " ");
            }
          }
          return issued;
        } catch {
          return "";
        }
      }),
    );
    badgeList = badgeList.map((badge, idx) => ({
      ...badge,
      issued: issuedDates[idx],
    }));
    const badges = { badgeList, badgeYears };
    sessionStorage.setItem("userBadges", JSON.stringify(badges));
    return badges;
  }
};

const fetchUserCertificates = async () => {
  const url = `${baseUrl}/local/report/certificates.php`;
  var certList = [];
  try {
    certList = JSON.parse(sessionStorage.getItem("userCerts"));
    console.log("Total Certificates: " + certList.length);
  } catch (error) {
    certList = [];
    console.log("Unable to fetch User Certificates from session.");
  }
  if (certList.length === 0) {
    var content = await fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error("Error fetching data");
      }
      return response.text();
    });
    const parser = new DOMParser();
    var webContent = parser.parseFromString(content, "text/html");
    const tables = webContent.getElementsByTagName("table");

    for (var i = 1; i < tables.length; i++) {
      var courseName = tables
        .item(i)
        .getElementsByTagName("td")
        .item(0).textContent;
      var certLoc = tables
        .item(2)
        .getElementsByTagName("td")
        .item(1)
        .getElementsByTagName("a")
        .item(0)
        .getAttribute("href");
      if (courseName !== "Certificate Name") {
        certList.push({
          key: i,
          courseName: courseName.replaceAll("\n", ""),
          certLocation: certLoc,
        });
      }
    }

    sessionStorage.setItem("userCerts", JSON.stringify(certList));
  }
  return certList;
};

const fetchUserLearningPlans = async () => {
  const dataURL =
    "https://catalys.portal.nttdataservices.com/local/report/lplan/userlp.php";

  try {
    const storedData = sessionStorage.getItem("userLearningPlans");
    if (storedData) {
      return JSON.parse(storedData);
    }

    const response = await fetch(dataURL);
    if (!response.ok) {
      throw new Error("Failed to fetch learning plans");
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const orgTabContent = doc.getElementById("nav-detail");
    const orgLearningPlans = extractOrgLearningPlans(orgTabContent);

    const myTabContent = doc.getElementById("nav-inprogress");
    const myLearningPlans = extractLearningPlans(myTabContent);

    const learningPlans = { orgLearningPlans, myLearningPlans };
    sessionStorage.setItem("userLearningPlans", JSON.stringify(learningPlans));

    return learningPlans;
  } catch (error) {
    console.error("Error fetching learning plans:", error.message);
    return { orgLearningPlans: [], myLearningPlans: [] };
  }
};
const extractLearningPlans = (myTabContent) => {
  const learningPlans = [];

  const accordionTitles = myTabContent.querySelectorAll(".accordion-title");
  const accordionContents = myTabContent.querySelectorAll(".accordion-content");

  accordionTitles.forEach((title, index) => {
    const plan = {};

    const titleRow = title.querySelector("table tr");
    if (titleRow) {
      const cells = titleRow.querySelectorAll("td");
      plan.learningPlanName = cells[0]?.textContent.trim() || "N/A";
      plan.assignedDate = cells[1]?.textContent.trim() || "N/A";
      plan.targetDate = cells[2]?.textContent.trim() || "N/A";
      plan.progress =
        cells[3]
          ?.querySelector(".progress-bar")
          ?.getAttribute("aria-valuenow") || "0";
    }

    const content = accordionContents[index];
    if (content) {
      const descriptionElement = content.querySelector(".bd-callout-info");
      if (descriptionElement) {
        const descriptionParagraphs = descriptionElement.querySelectorAll("p");
        plan.description =
          descriptionParagraphs[0]?.textContent
            .replace("Description : ", "")
            .trim() || "N/A";
        plan.createdBy =
          descriptionParagraphs[1]?.textContent
            .replace("Created By : ", "")
            .trim() || "N/A";
      }

      const courseRows = content.querySelectorAll("#trainintbl tr");
      plan.courses = [];
      courseRows.forEach((row, rowIndex) => {
        if (rowIndex === 0) return;
        const courseCells = row.querySelectorAll("td");
        plan.courses.push({
          courseName:
            courseCells[0]?.querySelector("a")?.textContent.trim() || "N/A",
          courseLink:
            courseCells[0]?.querySelector("a")?.getAttribute("href") || "N/A",
          source: courseCells[1]?.textContent.trim() || "N/A",
          status: courseCells[2]?.textContent.trim() || "N/A",
        });
      });
    }
    learningPlans.push(plan);
  });

  return learningPlans;
};

const extractOrgLearningPlans = (myTabContent) => {
  const learningPlans = [];

  const accordionTitles = myTabContent.querySelectorAll(".accordion-title");
  const accordionContents = myTabContent.querySelectorAll(".accordion-content");

  accordionTitles.forEach((title, index) => {
    const plan = {};

    const titleRow = title.querySelector("table tr");
    if (titleRow) {
      const cells = titleRow.querySelectorAll("td");
      plan.learningPlanName = cells[0]?.textContent.trim() || "N/A";
      plan.assignedDate = cells[2]?.textContent.trim() || "N/A";
      plan.targetDate = cells[3]?.textContent.trim() || "N/A";
      plan.progress =
        cells[3]
          ?.querySelector(".progress-bar")
          ?.getAttribute("aria-valuenow") || "0";
    }

    const content = accordionContents[index];
    if (content) {
      const descriptionElement = content.querySelector(".bd-callout-info");
      if (descriptionElement) {
        const descriptionParagraphs = descriptionElement.querySelectorAll("p");
        plan.description =
          descriptionParagraphs[0]?.textContent
            .replace("Description : ", "")
            .trim() || "N/A";
        plan.createdBy =
          descriptionParagraphs[1]?.textContent
            .replace("Created By : ", "")
            .trim() || "N/A";
      }

      const courseRows = content.querySelectorAll("#trainintbl tr");
      plan.courses = [];
      courseRows.forEach((row, rowIndex) => {
        if (rowIndex === 0) return;
        const courseCells = row.querySelectorAll("td");
        plan.courses.push({
          courseName:
            courseCells[0]?.querySelector("a")?.textContent.trim() || "N/A",
          courseLink:
            courseCells[0]?.querySelector("a")?.getAttribute("href") || "N/A",
          source: courseCells[1]?.textContent.trim() || "N/A",
          status: courseCells[2]?.textContent.trim() || "N/A",
        });
      });
    }
    learningPlans.push(plan);
  });

  return learningPlans;
};

export { fetchUserData };
export { fetchUserBadges };
export { fetchUserCertificates };
export { fetchUserLearningPlans };
